var map = {
	"./deals-01.png": 35737,
	"./deals-02.png": 85425,
	"./deals-03.png": 98072,
	"./deals-04.png": 887,
	"./deals-05.png": 95995,
	"./deals-06.png": 97899,
	"./deals-07.png": 70696,
	"./deals-08.png": 46816,
	"./deals-09.jpg": 60695
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12608;